import { createContext, useContext } from "react";
import type { OrganizationContextType } from "./OrganizationContext";

export const OrganizationContext = createContext<
  OrganizationContextType | undefined
>(undefined);

export const useOrganization = (): OrganizationContextType => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error(
      "useOrganization must be used within an OrganizationProvider",
    );
  }
  return context;
};
